import { ApiResponse } from 'apisauce';
import { useCallback, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import {
  setProfile,
  signOut,
} from '../../store/authentication/authenticationActions/authenticationActions';
import { api } from '../../utils/api/api';
import { useCookies } from 'react-cookie';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { UserRoles } from '../../types/models/user/user.types';
import { useCheckToken } from '../fetchers/useCheckToken/useCheckToken';
import { getStepIdFromENTStep } from '../../utils/helpers/user/getStep';
import { RegisterStepsList } from '../../components/pages/authentication/RegisterSteps/RegisterSteps.types';
import moment from 'moment';

const PREFIX = '[useConfigureApi]';

export const useConfigureApi = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [isReady, setReady] = useState(false);

  const { data, refetch: checkToken } = useCheckToken();

  const [cookies, setCookie] = useCookies(['token']);

  const monitor = useCallback(
    (response: ApiResponse<any, any>) => {
      if (response.status === 401) {
        console.log(PREFIX, 'Detected 401 status code... Request url was:', response.config?.url);
        const [, namespace, , , step] = location.pathname.split('/');
        const isNamespaceEscaped = (namespace: string) => {
          switch (namespace) {
            case 'register':
              return true;
            case 'password':
              return true;
          }
        };
        signOut(!isNamespaceEscaped(namespace) ? queryClient : undefined)(dispatch);
        if (namespace === '') return;
        if (namespace === 'login') return;
        if (namespace === 'password') return;
        if (namespace === 'step_wizard') return;
        if (namespace === 'register') return;
        if (namespace === 'dashboard_success') return;
        if (namespace === 'contact') return;
        if (namespace === 'register' && step === 'signup') return;
        navigate('/');
      }
    },
    [location]
  );

  useEffect(() => {
    api.addMonitor(monitor);
  }, [monitor]);

  useEffect(() => {
    const token = cookies['token'];
    if (token) {
      api.setHeader('authorization', `Bearer ${token}`);
    }
    checkToken();
    setReady(true);
  }, []);

  useEffect(() => {
    if (data) {
      setProfile(data)(dispatch);
      if (data.role === UserRoles.AcheteurPublic && data.id_step < 4) {
        navigate('/step_wizard/PUB');
      }
      if (data.role === UserRoles.Entreprise && data.id_step < 3) {
        const token = searchParams.get('success');
        if (token) {
          setProfile({ ...data, id_step: getStepIdFromENTStep(RegisterStepsList.Confirmation) })(
            dispatch
          );
          api.setHeader('authorization', `Bearer ${token}`);
          setCookie('token', token, {
            expires: moment().add(60, 'minutes').toDate(),
            path: '/',
          });
          navigate('/dashboard');
        } else {
          navigate('/step_wizard/ENT');
        }
      }
    }
  }, [data]);

  return isReady;
};
